"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rules = [
    {
        "from": "POS",
        "to": "VBZ",
        "type": 81,
        "c1": "that",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "POS",
        "to": "VBZ",
        "type": 81,
        "c1": "there",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "POS",
        "to": "VBZ",
        "type": 81,
        "c1": "where",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "POS",
        "to": "VBZ",
        "type": 81,
        "c1": "who",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "POS",
        "to": "VBZ",
        "type": 81,
        "c1": "everything",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "POS",
        "to": "VBZ",
        "type": 81,
        "c1": "everybody",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 24,
        "c1": "'s",
        "c2": "let",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 24,
        "c1": "us",
        "c2": "let",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "UH",
        "type": 12,
        "c1": "please",
        "c2": "VB",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "UH",
        "type": 12,
        "c1": "please",
        "c2": "JJ",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 6,
        "c1": "be",
        "secondRun": true,
    },
    {
        "from": "JJ",
        "to": "NNS",
        "type": 22,
        "cr": /^\d{2,}s$/,
        "secondRun": true,
    },
    {
        "from": "VB",
        "to": "UH",
        "type": 3,
        "c1": ",",
        "secondRun": true,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "UH",
        "type": 3,
        "c1": ".",
        "secondRun": true,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "UH",
        "type": 3,
        "c1": "\"",
        "secondRun": true,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "UH",
        "type": 23,
        "secondRun": true,
        "verify": true,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 13,
        "c1": "MD",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "POS",
        "to": "VBZ",
        "type": 8,
        "c1": "PRP",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "POS",
        "type": 8,
        "c1": "NN",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "MD",
        "to": "NNP",
        "type": 8,
        "c1": "DT",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "MD",
        "to": "NNP",
        "type": 8,
        "c1": "IN",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "MD",
        "to": "NNP",
        "type": 8,
        "c1": "JJ",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "POS",
        "type": 8,
        "c1": "NNS",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "POS",
        "type": 8,
        "c1": "NNP",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "POS",
        "type": 8,
        "c1": "NNPS",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "POS",
        "type": 8,
        "c1": "VB",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "VB",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NN",
        "c2": "'",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NNS",
        "c2": "'",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NNP",
        "c2": "'",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NNPS",
        "c2": "'",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NN",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NNS",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NNP",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "POS",
        "type": 8,
        "c1": "NNPS",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "VBN",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "VBG",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "VBD",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "VBP",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "VB",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "RB",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VB",
        "c2": "out",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBZ",
        "c2": "out",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBG",
        "c2": "out",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBN",
        "c2": "out",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBP",
        "c2": "out",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VB",
        "c2": "off",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBZ",
        "c2": "off",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBG",
        "c2": "off",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBN",
        "c2": "off",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBP",
        "c2": "off",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "VBD",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "IN",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "PRP$",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "WP$",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "VBZ",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "VBP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "JJ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "JJS",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "JJR",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "POS",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "CD",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 51,
        "c1": "the",
        "c2": "DT",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 15,
        "c1": "is",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 15,
        "c1": "are",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 5,
        "c1": "the",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "VB",
        "type": 5,
        "c1": "please",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 5,
        "c1": "those",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 5,
        "c1": "these",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 8,
        "c1": "NNP",
        "c2": "have",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 8,
        "c1": "EX",
        "c2": "have",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 8,
        "c1": "RB",
        "c2": "have",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 8,
        "c1": "RBR",
        "c2": "have",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "WDT",
        "type": 8,
        "c1": "NNS",
        "c2": "that",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "IN",
        "type": 8,
        "c1": "JJR",
        "c2": "like",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "IN",
        "type": 8,
        "c1": "RBR",
        "c2": "like",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "IN",
        "type": 8,
        "c1": "VBD",
        "c2": "like",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "IN",
        "type": 8,
        "c1": "VBN",
        "c2": "like",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "IN",
        "type": 8,
        "c1": "RB",
        "c2": "like",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "IN",
        "type": 8,
        "c1": "VBZ",
        "c2": "like",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "JJS",
        "type": 8,
        "c1": "DT",
        "c2": "latest",
        "secondRun": false,
    },
    {
        "from": "PRP$",
        "to": "PRP",
        "type": 8,
        "c1": "VBD",
        "c2": "her",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "NN",
        "type": 8,
        "c1": "CD",
        "c2": "fine",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "JJ",
        "to": "RB",
        "type": 8,
        "c1": "IN",
        "c2": "much",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "MD",
        "type": 8,
        "c1": "PRP",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "MD",
        "type": 8,
        "c1": "NNP",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "MD",
        "type": 8,
        "c1": "NN",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "MD",
        "type": 8,
        "c1": "NNS",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "MD",
        "type": 8,
        "c1": "CC",
        "c2": "may",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "NN",
        "type": 8,
        "c1": "CC",
        "c2": "chief",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "VB",
        "type": 8,
        "c1": "TO",
        "c2": "slow",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "VB",
        "type": 8,
        "c1": "MD",
        "c2": "slow",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "DT",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "JJR",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "JJ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "NN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "IN",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "SYM",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "VBD",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 2,
        "c1": "VBN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 172,
        "c1": "MD",
        "c2": "VB",
        "c3": "NN",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 172,
        "c1": "MD",
        "c2": "VB",
        "c3": "IN",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "VB",
        "type": 1,
        "c1": "MD",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "NN",
        "to": "VB",
        "type": 172,
        "c1": "VBN",
        "c2": "TO",
        "c3": "$",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "VB",
        "type": 172,
        "c1": "NNS",
        "c2": "TO",
        "c3": "JJ",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "VBG",
        "type": 2,
        "c1": "PRP",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "MD",
        "type": 12,
        "c1": "may",
        "c2": "VB",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "POS",
        "type": 12,
        "c1": "'s",
        "c2": "NN",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "POS",
        "type": 12,
        "c1": "'s",
        "c2": "NNS",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 21,
        "c1": "be",
        "secondRun": false,
    },
    {
        "from": "JJR",
        "to": "RBR",
        "type": 3,
        "c1": "JJ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "JJS",
        "to": "RBS",
        "type": 12,
        "c1": "most",
        "c2": "JJ",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "RB",
        "type": 121,
        "c1": "kind",
        "c2": "of",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "RB",
        "type": 121,
        "c1": "right",
        "c2": "after",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "RB",
        "type": 121,
        "c1": "close",
        "c2": "to",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "RB",
        "type": 121,
        "c1": "close",
        "c2": "to",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "NNP",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "DT",
        "type": 8,
        "c1": "VBZ",
        "c2": "no",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "NN",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "JJ",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "RB",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "VB",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "NNS",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "VBN",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "IN",
        "type": 8,
        "c1": "CD",
        "c2": "in",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RB",
        "type": 12,
        "c1": "as",
        "c2": "RB",
        "secondRun": false,
    },
    {
        "from": "WRB",
        "to": "RB",
        "type": 12,
        "c1": "when",
        "c2": "PRP",
        "secondRun": false,
    },
    {
        "from": "WRB",
        "to": "RB",
        "type": 8,
        "c1": "IN",
        "c2": "how",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "RB",
        "type": 8,
        "c1": "RB",
        "c2": "much",
        "secondRun": false,
    },
    {
        "from": "JJR",
        "to": "RBR",
        "type": 12,
        "c1": "more",
        "c2": "JJ",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VBD",
        "c2": "up",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RB",
        "type": 8,
        "c1": "CD",
        "c2": "up",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RB",
        "type": 8,
        "c1": "NN",
        "c2": "up",
        "secondRun": false,
    },
    {
        "from": "RP",
        "to": "RB",
        "type": 8,
        "c1": "VBD",
        "c2": "up",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "RP",
        "type": 8,
        "c1": "VB",
        "c2": "up",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "RP",
        "type": 8,
        "c1": "VB",
        "c2": "back",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "RP",
        "type": 8,
        "c1": "VBD",
        "c2": "back",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "RP",
        "type": 8,
        "c1": "VBG",
        "c2": "back",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "IN",
        "type": 81,
        "c1": "years",
        "c2": "ago",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "IN",
        "type": 81,
        "c1": "year",
        "c2": "ago",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "WDT",
        "type": 8,
        "c1": "NN",
        "c2": "that",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "WRB",
        "type": 12,
        "c1": "when",
        "c2": "PRP",
        "secondRun": false,
    },
    {
        "from": "DT",
        "to": "RB",
        "type": 12,
        "c1": "no",
        "c2": "RB",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "DT",
        "type": 12,
        "c1": "that",
        "c2": "NN",
        "secondRun": false,
    },
    {
        "from": "WDT",
        "to": "IN",
        "type": 12,
        "c1": "that",
        "c2": "NN",
        "secondRun": false,
    },
    {
        "from": "WDT",
        "to": "IN",
        "type": 12,
        "c1": "that",
        "c2": "DT",
        "secondRun": false,
    },
    {
        "from": "WDT",
        "to": "IN",
        "type": 12,
        "c1": "that",
        "c2": "PRP",
        "secondRun": false,
    },
    {
        "from": "WRB",
        "to": "RB",
        "type": 12,
        "c1": "when",
        "c2": "DT",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 3,
        "c1": "VBZ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBG",
        "to": "MD",
        "type": 6,
        "c1": "'ll",
        "secondRun": false,
    },
    {
        "from": "VBG",
        "to": "MD",
        "type": 6,
        "c1": "wo",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 13,
        "c1": "VBZ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 3,
        "c1": ".",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 3,
        "c1": "DT",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBG",
        "to": "VBP",
        "type": 2,
        "c1": "PRP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 2,
        "c1": "PRP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 2,
        "c1": "NNP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 2,
        "c1": "NN",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 2,
        "c1": "NNS",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 2,
        "c1": "WP",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 14,
        "c1": "NN",
        "c2": "RB",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 14,
        "c1": "PRP",
        "c2": "DT",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 2,
        "c1": "VBD",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 2,
        "c1": "VB",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 2,
        "c1": "VBG",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 2,
        "c1": "VBZ",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 2,
        "c1": "VBZ",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 2,
        "c1": "VBP",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 14,
        "c1": "RB",
        "c2": "TO",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 14,
        "c1": "VBZ",
        "c2": "JJ",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 14,
        "c1": "VBP",
        "c2": "JJ",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 171,
        "c1": "TO",
        "c2": "PRP",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 15,
        "c1": "by",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 15,
        "c1": "that",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 5,
        "c1": "which",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 5,
        "c1": "has",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 13,
        "c1": "VBD",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "VBN",
        "type": 5,
        "c1": "has",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 17,
        "c1": "MD",
        "secondRun": false,
    },
    {
        "from": "VBG",
        "to": "NN",
        "type": 2,
        "c1": "DT",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBG",
        "to": "NN",
        "type": 2,
        "c1": "JJ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBG",
        "to": "NN",
        "type": 2,
        "c1": "PRP$",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "RBS",
        "to": "JJS",
        "type": 2,
        "c1": "IN",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "VB",
        "type": 14,
        "c1": "TO",
        "c2": "DT",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "VB",
        "type": 14,
        "c1": "TO",
        "c2": "IN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 14,
        "c1": "PRP",
        "c2": "DT",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 14,
        "c1": "PRP",
        "c2": "IN",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 14,
        "c1": "MD",
        "c2": "VBN",
        "secondRun": false,
    },
    {
        "from": "MD",
        "to": "VBG",
        "type": 14,
        "c1": "VBZ",
        "c2": "TO",
        "secondRun": false,
    },
    {
        "from": "MD",
        "to": "VBG",
        "type": 14,
        "c1": "VBP",
        "c2": "TO",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 14,
        "c1": "MD",
        "c2": "TO",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 14,
        "c1": "TO",
        "c2": "DT",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 14,
        "c1": "PRP",
        "c2": "PRP",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBD",
        "type": 14,
        "c1": "PRP",
        "c2": "TO",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 14,
        "c1": "NNP",
        "c2": "DT",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 14,
        "c1": "PRP",
        "c2": "PRP",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 2,
        "c1": "NNS",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 51,
        "c1": "to",
        "c2": "TO",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "NN",
        "type": 51,
        "c1": "a",
        "c2": "DT",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 81,
        "c1": "may",
        "c2": "have",
        "secondRun": false,
    },
    {
        "from": "POS",
        "to": "PRP",
        "type": 81,
        "c1": "let",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "MD",
        "type": 6,
        "c1": "gon",
        "secondRun": false,
    },
    {
        "from": "VBP",
        "to": "VB",
        "type": 8,
        "c1": "MD",
        "c2": "have",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 8,
        "c1": "PRP",
        "c2": "plans",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 8,
        "c1": "NN",
        "c2": "plans",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 8,
        "c1": "NNP",
        "c2": "plans",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 8,
        "c1": "NNPS",
        "c2": "plans",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "NNP",
        "type": 12,
        "c1": "south",
        "c2": "NNP",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "NNP",
        "type": 12,
        "c1": "east",
        "c2": "NNP",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "NNP",
        "type": 12,
        "c1": "west",
        "c2": "NNP",
        "secondRun": false,
    },
    {
        "from": "RB",
        "to": "NNP",
        "type": 12,
        "c1": "north",
        "c2": "NNP",
        "secondRun": false,
    },
    {
        "from": "FW",
        "to": "NNP",
        "type": 12,
        "c1": "la",
        "c2": "NNP",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "NNP",
        "type": 12,
        "c1": "american",
        "c2": "NNP",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "NNP",
        "type": 12,
        "c1": "united",
        "c2": "NNP",
        "secondRun": false,
    },
    {
        "from": "WRB",
        "to": "RB",
        "type": 12,
        "c1": "when",
        "c2": "PRP",
        "secondRun": false,
    },
    {
        "from": "RBR",
        "to": "JJR",
        "type": 81,
        "c1": "year",
        "c2": "earlier",
        "secondRun": false,
    },
    {
        "from": "RBR",
        "to": "JJR",
        "type": 81,
        "c1": "years",
        "c2": "earlier",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "VB",
        "type": 14,
        "c1": "TO",
        "c2": "VBZ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBG",
        "to": "NN",
        "type": 2,
        "c1": "JJR",
        "secondRun": false,
    },
    {
        "from": "CD",
        "to": "NN",
        "type": 8,
        "c1": "DT",
        "c2": "one",
        "secondRun": false,
    },
    {
        "from": "CD",
        "to": "PRP",
        "type": 12,
        "c1": "one",
        "c2": "VBZ",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 2,
        "c1": "PRP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 2,
        "c1": "WDT",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 2,
        "c1": "WP",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "VBP",
        "type": 2,
        "c1": "PRP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "VBG",
        "secondRun": false,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "VBN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "VBD",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 2,
        "c1": "WDT",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 2,
        "c1": "WP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBZ",
        "to": "NNS",
        "type": 2,
        "c1": "IN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "WDT",
        "to": "IN",
        "type": 12,
        "c1": "that",
        "c2": "DT",
        "secondRun": false,
    },
    {
        "from": "IN",
        "to": "WDT",
        "type": 12,
        "c1": "that",
        "c2": "VBP",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "UH",
        "type": 12,
        "c1": "hell",
        "c2": "UH",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "UH",
        "type": 12,
        "c1": "hell",
        "c2": "RB",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 8,
        "c1": "PRP$",
        "c2": "bid",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "JJ",
        "type": 51,
        "c1": "is",
        "c2": "VBZ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "JJ",
        "type": 51,
        "c1": "are",
        "c2": "VBP",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "JJ",
        "type": 14,
        "c1": "NN",
        "c2": "JJ",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBN",
        "to": "JJ",
        "type": 14,
        "c1": "RB",
        "c2": "NN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "NN",
        "to": "VB",
        "type": 5,
        "c1": "will",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "VB",
        "type": 5,
        "c1": "will",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "NNP",
        "type": 5,
        "c1": "mr.",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 6,
        "c1": "has",
        "secondRun": false,
    },
    {
        "from": "VB",
        "to": "NN",
        "type": 5,
        "c1": "the",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBN",
        "type": 15,
        "c1": "with",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 6,
        "c1": "was",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 6,
        "c1": "is",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "VBP",
        "type": 6,
        "c1": "have",
        "secondRun": false,
    },
    {
        "from": "VBD",
        "to": "VBP",
        "type": 6,
        "c1": "have",
        "secondRun": false,
    },
    {
        "from": "VBN",
        "to": "VBD",
        "type": 6,
        "c1": "were",
        "secondRun": false,
    },
    {
        "from": "CD",
        "to": "NN",
        "type": 81,
        "c1": "no",
        "c2": "one",
        "secondRun": false,
    },
    {
        "from": "VBG",
        "to": "JJ",
        "type": 14,
        "c1": ",",
        "c2": "JJ",
        "secondRun": false,
    },
    {
        "from": "VBG",
        "to": "JJ",
        "type": 14,
        "c1": "DT",
        "c2": "JJ",
        "secondRun": false,
    },
    {
        "from": "VBG",
        "to": "JJ",
        "type": 14,
        "c1": ",",
        "c2": "NN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "VBG",
        "to": "JJ",
        "type": 14,
        "c1": "DT",
        "c2": "NN",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 8,
        "c1": "WDT",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 8,
        "c1": "DT",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNS",
        "to": "VBZ",
        "type": 8,
        "c1": "IN",
        "c2": "'s",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "UH",
        "type": 0,
        "c1": "RT",
        "secondRun": false,
    },
    {
        "from": "NNP",
        "to": "UH",
        "type": 0,
        "c1": "MT",
        "secondRun": false,
    },
    {
        "from": "JJ",
        "to": "VBN",
        "type": 14,
        "c1": "VBZ",
        "c2": "IN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "JJ",
        "to": "NN",
        "type": 14,
        "c1": "DT",
        "c2": "IN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "JJ",
        "to": "VBN",
        "type": 14,
        "c1": "VBP",
        "c2": "IN",
        "secondRun": false,
        "verify": true,
    },
    {
        "from": "NN",
        "to": "JJ",
        "type": 6,
        "c1": "first",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "JJ",
        "type": 6,
        "c1": "last",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "JJ",
        "type": 6,
        "c1": "high",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "JJ",
        "type": 6,
        "c1": "low",
        "secondRun": false,
    },
    {
        "from": "NN",
        "to": "JJ",
        "type": 6,
        "c1": "middle",
        "secondRun": false,
    },
    {
        "from": "",
        "type": null,
        "secondRun": false,
    },
];
